<template>
  <div class="ccui-home-navigation" ref="noPrintTop">
    <!-- 面包屑 -->
    <el-breadcrumb
      class="ccui-home-navigation-crumbs-container"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: homePageUrl }" v-if="isShowPortal"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item
        v-for="(item, index) in currBreadCrumb"
        :to="item.path"
        :key="index"
      >
        <span
          class="ccui-home-curr-crumb"
          v-if="index === currBreadCrumb.length - 1"
          :title="item.title"
          >{{ item.title }}</span
        >
        <span v-else>{{ item.title }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { getArgs } from "@/basa/utils";
export default {
  name: "baseBreadCrumb",
  props: {
    currBreadCrumb: {
      type: Array,
      default() {
        return [];
      }
    },
    isShowPortal: {
      //面包屑是否显示 首页（加这个是为了，搜索页面面包屑不显示 首页）
      type: Boolean,
      default: true
    }
  },
  computed: {
    homePageUrl() {
      if (!getArgs("ids")) {
        return "/";
      }
      // 新入口 首页
      const a = getArgs("a");
      const ids = getArgs("ids");
      return `/?a=${a}&ids=${ids}`;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .is-link:hover {
  color: #0089ef;
}
.ccui-home-curr-crumb {
  display: inline-block;
  width: 500px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
